// หัวข้อเนื้อหาของ /document-api?i=<id> เรียงตามเมนู (group = หัวกลุ่มใน sidebar)
import CredentialRequirements from "./credential-requirements.js";
import UserFlow from "./user-flow.js";
import SystemUsageFlow from "./system-usage-flow.js";
import ApiUsageFlow from "./api-usage-flow.js";
import CustomerKyc from "./customer-kyc.js";
import WhatIsAMismatch from "./what-is-a-mismatch.js";
import RefundProcess from "./refund-process.js";
import RefundPolicy from "./refund-policy.js";
import SettlementProcess from "./settlement-process.js";
import ConnectApi from "./connect-api.js";
import XSignature from "./x-signature.js";
import Callback from "./callback.js";
import Response from "./response.js";
import Postman from "./postman.js";

// menu = ชื่อในเมนู · title = หัวการ์ด
export const SECTION_GROUPS = [
  {
    group: "Introduction",
    items: [
      { id: "credential-requirements", menu: "Credential Requirements", title: "Credential Requirements", Component: CredentialRequirements },
      { id: "user-flow", menu: "User Flow", title: "User Flow", Component: UserFlow },
      { id: "system-usage-flow", menu: "System Usage Flow", title: "System Usage Flow", Component: SystemUsageFlow },
      { id: "api-usage-flow", menu: "API Usage Flow", title: "API Usage Flow", Component: ApiUsageFlow },
      { id: "customer-kyc", menu: "Customer KYC", title: "Customer KYC", Component: CustomerKyc },
      { id: "what-is-a-mismatch", menu: "What is a Mismatch?", title: "What Is a Mismatch Transaction?", Component: WhatIsAMismatch },
      { id: "refund-process", menu: "Refund Process", title: "Refund Process", Component: RefundProcess },
      { id: "refund-policy", menu: "Refund Policy", title: "Refund Policy", Component: RefundPolicy },
      { id: "settlement-process", menu: "Settlement Process", title: "Settlement Process", Component: SettlementProcess },
    ],
  },
  {
    group: null,
    items: [
      { id: "connect-api", menu: "Connect API", title: "Connect API", Component: ConnectApi },
      { id: "x-signature", menu: "X-Signature", title: "X-Signature", Component: XSignature },
      { id: "callback", menu: "Callback", title: "Response Callback", Component: Callback },
      { id: "response", menu: "Response", title: "Response", Component: Response },
      { id: "postman", menu: "Postman", title: "TEST API in Postman", Component: Postman },
    ],
  },
];

export const SECTIONS = Object.fromEntries(SECTION_GROUPS.flatMap((g) => g.items).map((s) => [s.id, s]));
